import {
    Box,
    Typography
} from '@mui/material';
import React, { useEffect } from 'react';





import Card from '@mui/material/Card';

import CardContent from '@mui/material/CardContent';




import { usePlayContext } from '../../utils/PlayContext';



 





const AboutPage = () => {

     
    const { 
        setAppTitle, 
      }=usePlayContext()

    useEffect(() => {
      setAppTitle(  ['Administration','About', ])  
      
      return () => {

      }

  }, [])

  
  

  return (
    <Box sx={{p:1}}>
        <Card sx={{width:'100%',  pt:2, mb:1, pb:0}} raised>
            
        <CardContent sx={{my:0, py:1}}> 
        <Typography variant="body2">VMS Title:VMS</Typography>
        <Typography variant="body2">VMS Description:Visitor Management System</Typography>
        <Typography variant="body2">VMS Company:NEC Asia Pacific Pte Ltd</Typography>
        <Typography variant="body2">VMS Product:VMS</Typography>
        <Typography variant="body2">VMS Version:{process.env.REACT_APP_VERSION}</Typography>  
        <br/>
        <Typography variant="body2">VMS Api Title:VMS Backend Api</Typography>
        <Typography variant="body2">VMS Api Description:Visitor Management System Backend Api</Typography>
        <Typography variant="body2">VMS Api Company:NEC Asia Pacific Pte Ltd</Typography>
        <Typography variant="body2">VMS Api Product:VMS</Typography>
        <Typography variant="body2">VMS Api Version:0.0.1-SNAPSHOT</Typography>
        </CardContent>
        </Card>
         
      </Box>
  );
};


export default AboutPage;
